import React from "react";
import {useParams} from "react-router-dom";
import LoadingSpinner from "../../../shared/components/LoadingSpinner";
import ErrorHandler from "../../../shared/components/ErrorHandler";
import {getPostDefaultValue} from "../../../shared/helpers/contents";
import {usePostDetailsQuery} from "../../../queries/PostDetails";
import PostForm from "../../../shared/components/form/events-form/PostForm";
import {useEditPostMutation} from "../../../mutations/UpdatePosts";
import env_const from "../../../config/env_const";
import NotAllowed401 from "../../DefaultPage/401";
import {useAddContentFormQuery} from "../../../queries/AddContentForm";
import Page from "../../../shared/components/Page";
import {PLATFORM_FEATURE_CONTENTS, PLATFORM_PERMISSION_EDITOR} from "../../../shared/helpers/features";
import LoadingSpinnerPage from "../../../shared/components/LoadingSpinnerPage";


const PostEdit = () => {
  const {postUid} = useParams();
  const {data, isError, isLoading, isIdle, error} = usePostDetailsQuery(postUid, true);
  const {
    tags: {data: dataTags, ...tagsProps},
    mitre: {data: dataMITRE, isLoading: isLoadingDataMITRE, isIdle: isIdleDataMITRE},
  } = useAddContentFormQuery();

  if (isLoading || isIdle || isLoadingDataMITRE || isIdleDataMITRE) {
    return <LoadingSpinnerPage/>
  }

  if (isError) {
    return <ErrorHandler error={error}/>
  }

  if (env_const.is_clone && !data.data.is_private) {
    return <Page><NotAllowed401 /></Page>
  }

  const defaultValues = getPostDefaultValue(data.data, dataMITRE);

  return (
    <Page
      feature={PLATFORM_FEATURE_CONTENTS}
      permission={PLATFORM_PERMISSION_EDITOR}
      onlyOnline
    >
      <PostForm
        defaultValues={defaultValues}
        mutationFn={useEditPostMutation}
        postUid={data.data.uid}
        editForm
      />
    </Page>
  )
}

export default PostEdit;
